import { render, staticRenderFns } from "./GeneralTeriageQuestion.vue?vue&type=template&id=0699b0f2&scoped=true&"
import script from "./GeneralTeriageQuestion.vue?vue&type=script&lang=js&"
export * from "./GeneralTeriageQuestion.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTeriageQuestion.vue?vue&type=style&index=0&id=0699b0f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0699b0f2",
  null
  
)

export default component.exports